<template>
  <label
    class="input-container"
    :class="{ error: errors.some((error) => error === inputName) }"
  >
    <span>{{ inputLabel || inputName }} {{ labelWithDots ? ":" : "" }}</span>
    <div class="input-wrapper">
      <input
        :type="inputType"
        :value="value"
        ref="input"
        @input="$emit('input', $event.target.value)"
      />
      <!-- Error icon -->
      <img
        v-if="errors.some((error) => error === inputName)"
        :src="`/assets/icons/ui/error-icon.png`"
        alt="error icon"
      />
    </div>
    <!-- Error message -->
    <span v-if="errors.some((error) => error === inputName)" class="error-msg"
      >Required</span
    >
  </label>
</template>

<script>
export default {
  name: "InputText",
  props: {
    errors: {
      type: Array,
      default: () => [],
    },
    focusOnMount: {
      type: Boolean,
      defualt: false,
    },
    inputLabel: {
      type: String,
      default: "",
    },
    labelWithDots: {
      type: Boolean,
      default: false,
    },
    inputName: {
      type: String,
      default: "input",
    },
    inputType: {
      type: String,
      default: "text",
    },
    value: {
      type: String,
      default: "",
    },
  },

  mounted() {
    if (this.focusOnMount) {
      this.$refs.input.focus();
    }
  },
};
</script>

<style lang="scss" scoped>
label.input-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 1rem;

  span {
    color: $darkerGray;
    font-size: 16px;
    padding-bottom: 16px;
    text-align: left;
    text-transform: capitalize;
  }

  .input-wrapper {
    display: flex;
    align-items: center;
    position: relative;
    img {
      position: absolute;
      margin-top: auto;
      margin-bottom: auto;
      right: 0.5em;
    }
  }

  input,
  textarea {
    background: $grey-lightest;
    border-radius: 5px;
    border: 1px solid $grey-light;
    font-size: 16px;
    padding: 0.65rem 0.5rem;
    font-family: "SlateStd", Helvetica, Arial;
    width: 100%;
    &:focus {
      outline: none;
      border: 2px solid #0751ed;
    }
  }

  textarea {
    min-height: 4rem;
    background-color: $whiteGray;
  }

  &.error {
    span {
      color: $redError;
    }
    input,
    textarea {
      border: 2px solid $redError;
    }

    span.error-msg {
      color: $redError;
      font-size: 0.75em;
      margin-top: 0.25rem;
      text-align: left;
    }
  }
}
</style>
